module.exports = __webpack_public_path__ + "img/case2.ee475b54.png";